import { Platform } from 'react-native';
import { translations } from '../src/i18n/translations';

export type SupportedLanguage = 'en' | 'es' | 'fr' | 'de' | 'it' | 'pt' | 'nl' | 'pl' | 'tr' | 'ru' | 'ar' | 'hi' | 'bn' | 'ja' | 'ko' | 'zh';

const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'es', 'fr', 'de', 'it', 'pt', 'nl', 'pl', 'tr', 'ru', 'ar', 'hi', 'bn', 'ja', 'ko', 'zh'];

let webLocalize: typeof import('./web-localization');

if (Platform.OS === 'web') {
  webLocalize = require('./web-localization');
}

export function getDefaultLanguage(): SupportedLanguage {
  if (Platform.OS === 'web' && webLocalize) {
    // Use web-specific localization
    const bestLanguage = webLocalize.findBestLanguageTag(SUPPORTED_LANGUAGES);
    if (bestLanguage) {
      return bestLanguage.languageTag as SupportedLanguage;
    }
    const deviceLocales = webLocalize.getLocales();
    if (deviceLocales.length > 0) {
      const primaryLocale = deviceLocales[0].languageCode;
      if (SUPPORTED_LANGUAGES.includes(primaryLocale as SupportedLanguage)) {
        return primaryLocale as SupportedLanguage;
      }
    }
  } else {
    // Try to use react-native-localize for native platforms
    try {
      const { findBestLanguageTag, getLocales } = require('react-native-localize');
      const bestLanguage = findBestLanguageTag(SUPPORTED_LANGUAGES);
      if (bestLanguage) {
        return bestLanguage.languageTag as SupportedLanguage;
      }
      const deviceLocales = getLocales();
      if (deviceLocales.length > 0) {
        const primaryLocale = deviceLocales[0].languageCode;
        if (SUPPORTED_LANGUAGES.includes(primaryLocale as SupportedLanguage)) {
          return primaryLocale as SupportedLanguage;
        }
      }
    } catch (error) {
      console.warn('Error loading react-native-localize:', error);
    }
  }
  
  // Default to English if no matches found
  return 'en';
}

// API configuration
export const API_URL = process.env.REACT_APP_API_URL;
export const API_ENDPOINTS = {
  chat: '/api/chat',
  tts: '/api/tts',
  stt: '/api/stt',
  llama: '/api/llama',
  tutors: '/api/tutors'
};
